import setupI18n from 'web-app/setup/i18next-setup';
const translationsLoadPath = `/{{lng}}-${process.env.APP_VERSION}.json`;
export default () => setupI18n(translationsLoadPath);
